import router from "@/routes/router";
import { http } from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
        
    };
};

const state = {
    client_upload_progress :0
};

const getters = {

};

const mutations = {
    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },
    updateProgress(state, data){
        state.client_upload_progress = data;
    }
};

const actions = {
    async getUserClaims({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Clients/Claims")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClaimDocuments({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Clients/ClaimDocuments/" + data.claim_id + "")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async uploadDocumentFile({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("Clients/UploadDocument/" + formData.get('documentId') + "", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateProgress', progress);
                        
                    }.bind(this)
                })
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }

                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },


};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
